
export const ALERT_AREA_MAX = 10000000;
export const ALERT_AGE_MAX = 1000;

export const DATE_FILTER_INITIAL = {
  dateStart: new Date('2016-01-02'),
  dateEnd: new Date()
}

export const INITIAL_FILTER_VALUES = {
  name: '',
  states: [],
  municipalities: [],
  indigenousLands: [],
  conservationUnits: [],
  status: [],
  maintenance: null,
  connectionType: [],
  contractType: null,
  partners: [],
  specialTerritories: [],
  energyKitModel: [],
  dateStart: DATE_FILTER_INITIAL.dateStart,
  dateEnd: DATE_FILTER_INITIAL.dateEnd,
  declaredTerritory: [],
  workGroups: [],
  association: null,
  routerModel: []
}
